
export const quartileOptions = {
  1: 'Q1',
  2: 'Q2',
  3: 'Q3',
  4: 'Q4',
}

export const vakOptions = {
  1: 'К1',
  2: 'К2',
  3: 'К3',
}


export const whitelistOptions = {
  1: 'У1',
  2: 'У2',
  3: 'У3',
  4: 'У4',
}


export const indexOptions = [
  { label: 'SJR', value: 'sjr' },
  { label: 'Google Scholar', value: 'google_scholar' },
  { label: 'eLibrary', value: 'elibrary' },
  { label: 'Mendeley', value: 'mendeley' },
  { label: 'CrossRef', value: 'cross_ref'},
  { label: 'CyberLeninka', value: 'cyber_leninka'},
  { label: 'Белый список', value: 'white_list'},
  { label: 'OpenAlex', value: 'open_alex'},
  // TODO: implement the following indexes
  // { label: 'OpenAlex', value: 'openalex' },
  // { label: 'CrossRef', value: 'crossref' },
  // { label: 'Киберленинка', value: 'cyberleninka' },

  // { label: 'Science индекс', value: 'science' },
]

